<template>
  <div class="filter-box">
    <a-cascader v-model="searchKeyWord" :showSearch="{ filter: handleSearchChange, matchInputWidth: true }" :options="searchList" :placeholder="placeholder || '您想看哪个品类的国家&地区排行？'"
      expandTrigger="hover" @change="searchChange" :changeOnSelect="true" style="width: 320px;vertical-align: middle;" 
    >
    </a-cascader>
    <div class="selected-tag" v-if="multiple">
      <div class="selected-tags" 
        @mouseenter="hoverFlag = i" @mouseleave="hoverFlag = null" 
        v-for="(v,i) in value" :key="v"
      ><span>{{ tagName(v) }}</span><a-icon @click="close(i)" type="close-circle" class="close" v-if="hoverFlag === i"></a-icon></div>
    </div>
    <div class="tag-box">
      <span class="title">常用品类</span>
      <a-checkable-tag key="ALL" v-if="!multiple"
        :checked="value === 'ALL'"
        @change="checked => handleChange('ALL')"
      >全部</a-checkable-tag>
      <template v-for="tag in categoryList">
        <a-checkable-tag  :key="tag.categoryCode"
          :checked="tagChecked(tag.categoryCode)"
          @change="checked => handleChange(tag.categoryCode, checked)"
        >
          {{ tag.categoryName }}
        </a-checkable-tag>
      </template>
    </div>
    <div class="tag-box">
      <span class="title">常用子类</span>
        <a-checkable-tag key="ALL"  v-if="!multiple"
          :checked="value === 'ALL'"
          @change="checked => handleChange('ALL')"
        >全部</a-checkable-tag>
        <template v-for="tag in childCategoryList">
          <a-checkable-tag  :key="tag.categoryCode"
            :checked="tagChecked(tag.categoryCode)"
            @change="checked => handleChange(tag.categoryCode, checked)"
          >
            {{ tag.categoryName }}
          </a-checkable-tag>
        </template>
    </div>
  </div>  
</template>
<script>
import { getCategory } from '@/api/mediadata'

export default {
	name: 'CategorySelect',
  props: {
    value: [Array, String],
    getData: Function,
    multiple: Boolean,
    placeholder: String
  },
  data() {
    return {
      searchKeyWord: [],
      searchList: [],
      categoryList: [],
      childCategoryList: [],
      hoverFlag: null,
      tagCache: []
    }
  }, 
	methods: {
    tagName(v) {
      let obj =  this.tagCache.find(val => val.categoryCode === v)
      return obj?.categoryName || v
    },
    tagChecked(code) {
      return this.multiple?this.value.indexOf(code) > -1:this.value === code
    },
    searchChange() {
      let code = this.searchKeyWord[this.searchKeyWord.length - 1]
      if(!this.multiple) {
        this.$emit('input', code)
      } else if(this.value.indexOf(code) === -1) {
        if(this.value.length >= 6) return;
        this.$emit('input', [...this.value, code])
      }
			this.getData()
		},
    handleSearchChange(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
		},
    handleChange (tag, checked) {
      if(!this.multiple) {
        this.$emit('input', tag)
      } else {
        if(this.value.length >= 6) return;
        if(this.value.indexOf(tag) === -1) {
          this.$emit('input', [...this.value, tag])
        } else {
          this.$emit('input', this.value.filter(v => v !== tag))
        }
      }
			this.searchKeyWord = []
			this.getData()
		},
    // 获取品类
		getCategory() {
			getCategory({
				commonlyUsedFlag: 1
      }).then((res) => {
        this.categoryList = res.data || []
				let arr = []
				for (let i = 0; i < this.categoryList.length; i++) {
					const ele = this.categoryList[i];
					arr = arr.concat(ele.childCategoryList || [])
				}
				this.childCategoryList = arr
      })
		},
    getSearchList() {
			getCategory({}).then(res => {
				let data = res.data || [];
				let arr = []
				for (let i = 0; i < data.length; i++) {
					let obj = {
						value: data[i].categoryCode,
						label: data[i].categoryName,
						children: data[i].childCategoryList.map(v => ({ 
							value: v.categoryCode,
							label: v.categoryName,
						}))
					}
					arr.push(obj)
				}
				this.searchList = arr;
        this.addCache(data)
			}); 
		},
    addCache(data) {
      this.tagCache = this.tagCache.concat(data)
      data.forEach(ele => {
        this.tagCache = this.tagCache.concat(ele.childCategoryList)
      });
    },
    close(i) {
      let arr = JSON.parse(JSON.stringify(this.value))
      arr.splice(i, 1)
      this.$emit('input', arr)
			this.getData()
    }
  },
  mounted() {
    this.getCategory()
		this.getSearchList()
  }
}
</script>
<style scoped lang="less">
.selected-tag {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  .selected-tags {
    vertical-align: middle;
    height: 22px;
    background: #c7eacc;
    border-radius: 4px 4px 4px 4px;
    display: inline-block;
    margin-right: 4px;
    text-align: center;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    font-weight: 400;
    color: #0d8417;
    position: relative;
    white-space: nowrap;
    text-overflow:ellipsis;
    overflow:hidden;
    max-width: calc(100% - 4px);
    .close {
      background: #fff;
      font-size: 14px;
      position: absolute;
      top: 4px;
      right: 4px;
      border-radius: 50%;
      // color: #fff;
      cursor: pointer;
    }
  }
}
</style>